/**
 * Created by TzuHsing on 2020-02-15
 */

export const UPLOADED = 'UPLOADED'
export const UNPUBLISHED = 'UNPUBLISHED'
export const UNCHECK = 'UNCHECK'
export const DELETED = 'DELETED'

export const GETADV_UPLOADEDLIST = 'GETADV_UPLOADEDLIST'
export const GETADV_UNPUBLISHEDLIST = 'GETADV_UNPUBLISHEDLIST'
export const GETADV_UNCHECKLIST = 'GETADV_UNCHECKLIST'
export const GETADV_DELETEDLIST = 'GETADV_DELETEDLIST'
export const GETADV_UNIONLIST = 'GETADV_UNIONLIST'
export const OK = 1
export const MISSPARAM = 3
export const FAILTOUPDATEADV = 1004


// WEBPACK FOOTER //
// ./src/containers/CheckOutAdvManage/constants.js